import { VOUCHER_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";

export interface IVoucherSubCategoryData {
  subcategory_id: string;
  subcategory_name: string;
  is_medicine: boolean;
}

export interface IVoucherCategoryWithSubCategoriesData {
  id: string;
  category_name: string;
  clinic_or_tams: string | null;
  subcategories: IVoucherSubCategoryData[];
}

export interface IVoucherCategorySubCategoryResponse {
  status: boolean;
  message: string;
  data: IVoucherCategoryWithSubCategoriesData[];
}

type VoucherCategorySubCategoryAPIResponse = { status: boolean; message: string | null };

AxiosCurlirize(axios, () => {});

export const useVoucherCategorySubCategoryAPI = () => {
  const [categorySubCategory, setCategorySubCategory] = useState<IVoucherCategoryWithSubCategoriesData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (category_id?: string) => {
      setIsLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: VoucherCategorySubCategoryAPIResponse = await axios
          .get(VOUCHER_APIS?.VOUCHER_CATEGORY_SUB_CATEGORY?.baseURL ?? "", {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
            params: category_id ? { category_id } : {},
          })
          .then((res: AxiosResponse<IVoucherCategorySubCategoryResponse>) => {
            if (res.data.status) {
              setCategorySubCategory(Array.isArray(res.data.data) ? res.data.data : []);
              return { status: true, message: res.data.message ?? null };
            }
            setCategorySubCategory([]);
            return { status: false, message: res.data.message ?? null };
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config?.["curlCommand"]);
            setCategorySubCategory([]);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        setCategorySubCategory([]);
        return { status: false, message: null };
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch],
  );

  return { execute, categorySubCategory, isLoading };
};
